import React from 'react';
import ReactDOM from 'react-dom';
import App from './containers/App';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { I18nextProvider } from 'react-i18next';
import i18next from 'i18next';
import common_it from './translations/it/common.json';
import common_en from './translations/en/common.json';
import menu_it from './translations/it/menu.json';
import menu_en from './translations/en/menu.json';
import members_en from './translations/en/members.json';
import members_it from './translations/it/members.json';
import pages_it from './translations/it/pages.json';
import pages_en from './translations/en/pages.json';
import org_structure_en from './translations/en/orgStructure.json';
import org_structure_it from './translations/it/orgStructure.json';
import { ThemeProvider } from '@mui/system';
import { HelmetProvider } from 'react-helmet-async';
import theme from './theme/theme';
import smoothscroll from 'smoothscroll-polyfill';

const langFromLocalStorage = localStorage.getItem('language');

smoothscroll.polyfill();
i18next.init({
  interpolation: { escapeValue: false }, // React already does escaping
  lng: langFromLocalStorage ? langFromLocalStorage : 'it', // language to use
  resources: {
    en: {
      common: common_en, // 'common' is our custom namespace
      menu: menu_en,
      pages: pages_en,
      members: members_en,
      orgStructure: org_structure_en,
    },
    it: {
      common: common_it,
      menu: menu_it,
      pages: pages_it,
      members: members_it,
      orgStructure: org_structure_it,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <I18nextProvider i18n={i18next}>
      <ThemeProvider theme={theme}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </ThemeProvider>
    </I18nextProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
